import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuPaintingPlanView } from "src/tenantCustomizations/tenants/mellano/views/luukku/productionPlanning/MellanoLuukkuPaintingPlanView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/paintingPlan")({
	staticData: { title: "TS, maalaus", legacyViewKey: "mellanoLuukkuPaintingPlanView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuPaintingPlanView productionLine={"1"} />;
}
